import { useLanguage } from "@/components/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = t.marquee;

  const Row = ({ hidden = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-mono text-sm uppercase tracking-[0.3em] text-bone/60">{item}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="services-marquee" className="overflow-hidden py-8">
      <div className="-rotate-1">
        <div className="-mx-2 border-y border-bone/10 bg-dark2 py-4">
          <div className="marquee-track">
            <Row />
            <Row hidden />
          </div>
          <div className="marquee-track marquee-reverse mt-3 opacity-50">
            <Row />
            <Row hidden />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marquee;
